<template>
  <div
    class="Others3Charts"
    :style="{
      background: `${
        ProjectInfo.Style.componentName == 'V3Style'
          ? 'linear-gradient(to bottom, rgba(5, 44, 87,0.7), transparent 20%,transparent, transparent 80%,rgba(5, 44, 87,0.7) 100%)'
          : 'rgba(8, 27, 49, 0.842)'
      }`,
    }"
  >
    <!-- 除了V3其他通用的 -->
    <div class="text-board" :class="getStyle('title')" v-if="ProjectInfo.Style.componentName != 'V3Style'">
      <img src="@/assets/img/V4heightLight.png" v-if="ProjectInfo.Style.componentName == 'V4Style'" alt="" />
      <img
        src="@/assets/img/V11heightLight.png"
        v-else-if="ProjectInfo.Style.componentName == 'V11Style'"
        alt=""
      />
      <img
        src="@/assets/img/V5heightLight.png"
        v-else-if="
          ProjectInfo.Style.componentName == 'V5Style' || ProjectInfo.Style.componentName == 'V10Style'
        "
        alt=""
      />
      <img src="@/assets/img/heightLight.png" v-else alt="" />

      <div class="text-board-text">
        <!-- 数据 -->
        <div class="text-board-text-item">
          <!-- :style="{
            fontSize: `${$w_Ratio(4 + getShowfontSizeBase(), $store)}px`,
          }" -->
          <div
            class="v-text-title"
            :style="{
              fontSize: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
            }"
          >
            {{ data1.name }}
          </div>
          <div class="v-text-icon icon-1"></div>
          <div
            class="v-text-data"
            :style="{
              fontSize: `${$w_Ratio(10 + getShowfontSizeBase(), $store)}px`,
            }"
          >
            <CountTo :startVal="0" :endVal="data1.value" :decimals="data1.decimals" :duration="2000">
            </CountTo>
            <span
              :style="{
                fontSize: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
              }"
              class="v-text-unit"
              >{{ data1.unit }}</span
            >
          </div>
        </div>

        <div class="vertical-line"></div>

        <div
          class="text-board-text-item"
          :style="{
            fontSize: `${$w_Ratio(10 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          <div
            class="v-text-title"
            :style="{
              fontSize: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
            }"
          >
            {{ data2.name }}
          </div>
          <div class="v-text-icon icon-2"></div>
          <div
            class="v-text-data"
            :style="{
              fontSize: `${$w_Ratio(10 + getShowfontSizeBase(), $store)}px`,
            }"
          >
            <CountTo :startVal="0" :endVal="data2.value" :decimals="data2.decimals" :duration="2000">
            </CountTo>
            <span
              :style="{
                fontSize: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
              }"
              class="v-text-unit"
              >{{ data2.unit }}</span
            >
          </div>
        </div>
        <div class="vertical-line"></div>
        <div
          class="text-board-text-item"
          :style="{
            fontSize: `${$w_Ratio(8 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          <div
            class="v-text-title"
            :style="{
              fontSize: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
            }"
          >
            {{ data3.name }}
          </div>
          <div class="v-text-icon icon-3"></div>
          <div
            class="v-text-data"
            style="color: #305fee"
            :style="{
              fontSize: `${$w_Ratio(10 + getShowfontSizeBase(), $store)}px`,
            }"
          >
            <CountTo :startVal="0" :endVal="data3.value" :decimals="data3.decimals" :duration="2000">
            </CountTo>
            <span
              :style="{
                fontSize: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
              }"
              class="v-text-unit"
            >
              {{ data3.unit }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- V3专用 -->
    <div class="text-board text-board-v3" :class="getStyle('Style')" v-else>
      <div class="text-board-text">
        <!-- 数据 -->
        <div
          class="text-board-text-item"
          :style="{
            fontSize: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          <div
            class="text-img"
            :style="{
              width: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
              height: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
            }"
          >
            <img class="v3-img" src="../../../assets/img/v3_1.png" alt="" />
          </div>
          <div class="v-text-title">{{ data1.name }}</div>
          <!-- <div class="v-text-icon icon-1"></div> -->
          <div class="v-text-data1">
            <span
              :style="{
                fontSize: `${$w_Ratio(12.5 + getShowfontSizeBase(), $store)}px`,
              }"
            >
              <CountTo
                :style="{
                  fontSize: `${$w_Ratio(12.5 + getShowfontSizeBase(), $store)}px`,
                }"
                :startVal="0"
                :endVal="data1.value"
                :decimals="data1.decimals"
                :duration="2000"
              >
              </CountTo>
            </span>
            <span>{{ data1.unit }}</span>
          </div>
        </div>

        <!-- <div class="vertical-line"></div> -->

        <div
          class="text-board-text-item"
          :style="{
            fontSize: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          <div
            class="text-img"
            :style="{
              width: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
              height: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
            }"
          >
            <img class="v3-img" src="../../../assets/img/v3_2.png" alt="" />
          </div>
          <div class="v-text-title">{{ data2.name }}</div>
          <div class="v-text-data2">
            <span
              :style="{
                fontSize: `${$w_Ratio(12.5 + getShowfontSizeBase(), $store)}px`,
              }"
            >
              <CountTo
                :style="{
                  fontSize: `${$w_Ratio(12.5 + getShowfontSizeBase(), $store)}px`,
                }"
                :startVal="0"
                :endVal="data2.value"
                :decimals="data2.decimals"
                :duration="2000"
              >
              </CountTo>
            </span>
            <span>{{ data2.unit }}</span>
          </div>
        </div>
        <!-- <div class="vertical-line"></div> -->
        <div
          class="text-board-text-item"
          :style="{
            fontSize: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          <div
            class="text-img"
            :style="{
              width: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
              height: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
            }"
          >
            <img class="v3-img" src="../../../assets/img/v3_3.png" alt="" />
          </div>
          <div class="v-text-title">
            {{ data3.name }}
          </div>
          <div class="v-text-data3" style="color: #305fee">
            <!-- class="text-nowrap" -->
            <span
              :style="{
                fontSize: `${$w_Ratio(12.5 + getShowfontSizeBase(), $store)}px`,
              }"
            >
              <CountTo
                :style="{
                  fontSize: `${$w_Ratio(12.5 + getShowfontSizeBase(), $store)}px`,
                }"
                :startVal="0"
                :endVal="data3.value"
                :decimals="data3.decimals"
                :duration="2000"
              >
              </CountTo>
            </span>
            <span>{{ data3.unit }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CountTo } from 'vue3-count-to';
import { request } from '../../../common/request';

export default {
  name: 'Others3Charts',
  components: { CountTo },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      numberintervalTask1: null,
      numberintervalTask2: null,
      numberintervalTask3: null,
      val1: 0,
      val2: 0,
      val3: 0,
      data1: {
        name: '今日售票额',
        value: 0,
        unit: '元',
        decimals: 0,
      },
      data2: {
        name: '本周售票额',
        value: 0,
        unit: '元',
        decimals: 0,
      },
      data3: {
        name: '本月售票额',
        value: 0,
        unit: '元',
        decimals: 0,
      },
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    // clearInterval(this.numberintervalTask1);
    // clearInterval(this.numberintervalTask2);
    // clearInterval(this.numberintervalTask3);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    // this.setNumberinterval();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    // clearInterval(this.numberintervalTask1);
    // clearInterval(this.numberintervalTask2);
    // clearInterval(this.numberintervalTask3);
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    setNumberinterval() {
      this.numberintervalTask1 = setInterval(() => {
        this.val1 = 0;

        setTimeout(() => {
          this.val1 = this.data1.value;
        }, 0);
      }, 5000);
      this.numberintervalTask2 = setInterval(() => {
        this.val2 = 0;

        setTimeout(() => {
          this.val2 = this.data2.value;
        }, 0);
      }, 7000);
      this.numberintervalTask3 = setInterval(() => {
        this.val3 = 0;

        setTimeout(() => {
          this.val3 = this.data3.value;
        }, 0);
      }, 9000);
    },

    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          style = {};
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          style = {};
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      console.log(source);
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(grid);

      let xData = [];
      let yData = [];
      let xyData = [];
      let unit = '';

      function DealData() {
        seriesList.forEach(s => {
          source.forEach((item, index) => {
            if (s === item.s) {
              unit = item.s;
              if (index >= 4) return;
              xData.push(item.x);
              yData.push(item.y);
              // decimals 数值 小数点留位
              xyData.push({
                name: item.x,
                value: Number(item.y),
                decimals: item.d,
              });
            }
          });
        });
      }
      DealData();

      // console.log(xyData, 'xyData xyData');
      this.data1.unit = unit;
      this.data2.unit = unit;
      this.data3.unit = unit;

      if (xyData[0]) {
        this.data1.name = xyData[0].name;
        this.data1.value = xyData[0].value;
        this.data1.decimals = xyData[0].decimals;
      }
      if (xyData[1]) {
        this.data2.name = xyData[1].name;
        this.data2.value = xyData[1].value;
        this.data2.decimals = xyData[0].decimals;
      }
      if (xyData[2]) {
        this.data3.name = xyData[2].name;
        this.data3.value = xyData[2].value;
        this.data3.decimals = xyData[0].decimals;
      }

      console.log(unit);
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);
          data.source.forEach(item => {
            item.y = 0;
          });
          this.setEchartsOptions(data);
          setTimeout(() => {
            this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData));
          }, 0);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        // this.axios({
        //   method: 'get',
        //   url: ChartsData.apiData.apiUrl,
        // })
        let param = {
          method: 'get',
          url: ChartsData.apiData.apiUrl,
        };

        request(param)
          .then(res => {
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function(data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '基础文字',
    componentName: 'Others3Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others3Charts.png',
    id: '',
    style: {
      width: 462,
      height: 194,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        // propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果        
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['元'],
            source: [
              {
                s: '元',
                y: '122',
                x: '今日售票额',
              },
              {
                s: '元',
                y: '67',
                x: '本周售票额',
              },
              {
                s: '元',
                y: '55',
                x: '本月售票额',
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Others3Charts {
  color: white;
  background-color: rgba(8, 27, 49, 0.842);
  width: 100%;
  height: 100%;
  border-radius: 2px;
  .text-board {
    margin-top: 10px;
    position: relative;
    width: 100%;
    height: 100%;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .text-board-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .vertical-line {
        width: 2px;
        flex-shrink: 0;
        height: 80%;
        background-color: rgba(52, 99, 160, 0.733);
      }
      .text-board-text-item {
        padding: 3% 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        .v-text-icon {
          margin: 0% 0;
          width: 19px;
          height: 22px;
        }
        .icon-1 {
          background: url(../../../assets/img/pwsjIcons1.png) no-repeat;
          background-size: 111px 125px;
          background-position-x: 21%;
          background-position-y: 79%;
        }
        .icon-2 {
          background: url(../../../assets/img/pwsjIcons2.png) no-repeat;
          background-size: 111px 125px;
          background-position-x: 76%;
          background-position-y: 79%;
        }
        .icon-3 {
          background: url(../../../assets/img/pwsjIcons1.png) no-repeat;
          background-size: 111px 125px;
          background-position-x: 79%;
          background-position-y: 79%;
        }
      }
      .text-board-text-item:nth-child(3) {
        color: rgb(0, 209, 167);
      }
    }
  }
  .text-board-v3 {
    .text-img {
      /* width: 70px;
      height: 70px; */
      position: relative;

      .v3-img {
        position: absolute !important;
        // top: -10px;
        width: 100%;
      }
    }

    .v-text-title {
      color: #b1d3fd !important;
      margin-bottom: 4px;
    }

    .v-text-data1 {
      background: linear-gradient(to bottom, #ffb487, #ff6958);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      span:nth-child(1) {
        font-weight: bold;
        font-style: italic;
        font-size: 24px;
      }
      span:nth-child(2) {
        margin-left: 6px;
        font-size: 12px;
      }
    }
    .v-text-data2 {
      background: linear-gradient(to bottom, #d7feff, #2afff7);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      span:nth-child(1) {
        font-weight: bold;
        font-style: italic;
        font-size: 24px;
      }
      span:nth-child(2) {
        margin-left: 6px;
        font-size: 12px;
      }
    }
    .v-text-data3 {
      background: linear-gradient(to bottom, #fffed4, #e8e838);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      span:nth-child(1) {
        font-weight: bold;
        font-style: italic;
        font-size: 24px;
      }
      span:nth-child(2) {
        margin-left: 6px;
        font-size: 12px;
      }
      .text-nowrap {
        white-space: nowrap;
      }
    }
  }
  .V1Style {
    margin-top: 10px !important;
  }
  .V2Style {
    margin-top: 10px !important;
  }
  .V5Style {
    margin-top: 10px !important;
  }
  .V6Style {
    margin-top: 10px !important;
  }
  .V7Style {
    margin-top: 10px !important;
  }
  .V9Style {
    margin-top: 10px !important;
  }
  .V10Style {
    margin-top: 10px !important;
  }
  .V11Style {
    .text-board-text .vertical-line {
      width: 0 !important;
    }
    .v-text-title {
      color: #fff;
    }
    .text-board-text-item .icon-2,
    .text-board-text-item .icon-1,
    .text-board-text-item .icon-3 {
      background: url(../../../assets/img/icon-2.png) no-repeat !important;
    }
    .v-text-unit {
      font-weight: 300 !important;
      margin-left: 6px !important;
    }
    .v-text-data {
      font-weight: bold;
      color: #bc8537 !important;
    }
  }
}
@media screen and (min-width: 3300px) {
  .Others3Charts .text-board-v3 .v-text-data1 span:nth-child(1) {
    font-size: 30px !important;
  }
  .Others3Charts .text-board-v3 .v-text-title {
    font-size: 30px !important;
  }
  .Others3Charts .text-board-v3 .v-text-data2 span:nth-child(1) {
    font-size: 30px !important;
  }
  .Others3Charts .text-board-v3 .v-text-data3 span:nth-child(1) {
    font-size: 30px !important;
  }
  .Others3Charts .text-board-v3 .text-img {
    width: 120.96px !important;
    height: 122.96px !important;
  }
}
</style>
